import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { GridicsUseTagService } from 'src/app/core/services/gridics-use-tag.service';
import {
    GridicsUseTagEditPopupComponent,
    IGridicsUseTagEditData
} from './gridics-use-tag-edit-popup/gridics-use-tag-edit-popup.component';
import { ConfirmationDialogComponent } from 'src/shared/zoneiqui/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    standalone: false,
    selector: 'app-gridics-uses-tags-management-page',
    templateUrl: './gridics-uses-tags-management-page.component.html',
    styleUrls: ['./gridics-uses-tags-management-page.component.scss']
})
export class GridicsUsesTagsManagementPageComponent implements OnInit {
    tableFields = ['Gridics Use', 'Actions'];

    get useTags$(): Observable<IGridicsUseTag[]> {
        return this.gridicsUseTagService.gridicsUseTags.asObservable();
    }

    constructor(private readonly gridicsUseTagService: GridicsUseTagService, private readonly dialog: MatDialog) {}

    ngOnInit(): void {
        this.gridicsUseTagService.getAll().subscribe();
    }

    createUseTag() {
        const data: IGridicsUseTagEditData = {
            record: null,
            existingRecords: this.gridicsUseTagService.gridicsUseTags.value
        };

        this.dialog.open(GridicsUseTagEditPopupComponent, {
            width: '400px',
            data
        });
    }

    editUseTag(useTag: IGridicsUseTag) {
        const data: IGridicsUseTagEditData = {
            record: useTag,
            existingRecords: this.gridicsUseTagService.gridicsUseTags.value
        };

        this.dialog.open(GridicsUseTagEditPopupComponent, {
            width: '400px',
            data
        });
    }

    deleteUseTag(useTag: IGridicsUseTag) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Delete Gridics Use Tag',
            topContent: `Gridics Use Tag "${useTag.GridicsUse}" will be deleted. Continue?`
        };

        const deleteUseTagRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        deleteUseTagRef.afterClosed().subscribe(needToDelete => {
            if (!needToDelete) {
                return;
            }

            this.gridicsUseTagService.deleteGridicsUseTag(useTag.Id).subscribe();
        });
    }
}
